import { Checkbox, TableBody, TableCell } from '@material-ui/core'
import React, { useContext, useEffect, useState } from 'react'
import CustomPagination from '../../components/CustomPagination'
import Layout from '../../components/Layout'
import CustomTable from '../../components/Table/CustomTable'
import CustomTableHeading from '../../components/Table/CustomTableHeading'
import CustomTableRow from '../../components/Table/CustomTableRow'
import { ConfigurationContext } from '../../context api/Configuration/ConfigurationContext'
import { useIncentive } from '../../hooks/Features/useIncentive'

import { formatDate, formatNumber, paginatedData, paginatePages } from '../../shared/constants'
import { AiOutlineInfoCircle } from 'react-icons/ai'
import { useHistory } from 'react-router'
import { NoDataFound } from '../../components/NoDataFound'
import Loader from '../../components/Loader'
import { FeatureContext } from '../../context api/Features/FeatureContext'
import { SortIcon, FilterIcon } from '../../components/CustomComponents/CustomFilterIcon'
import moment from 'moment'

export default function AchievementReport() {
  const { incentives, loading, paginate, getAchievementReport, downloadKeys, downloadLoading, pdfCsvData, getPdfCsvData } = useIncentive()

  const [searchQuery, setSearchQuery] = useState('')

  const [page, setPage] = React.useState(1)

  const startDate = moment().startOf('quarter')
  const [from, setFrom] = useState(startDate.toISOString())
  const [to, setTo] = useState(new Date().toISOString())

  const [filterParams, setFilterParams] = useState({ storeName: null, firstName: 1 })

  const handleChange = (event, value) => {
    setPage(value)
  }

  useEffect(() => {
    getAchievementReport({ page, from, to, ...filterParams, searchQuery, page })
  }, [page, from, to, filterParams, searchQuery, page])

  useEffect(() => {
    getPdfCsvData(downloadKeys.ACHIEVEMENT_REPORT, { from, to })
  }, [from, to])

  const noOfPages = paginate.totalPage

  return (
    <Layout
      heading="Achievement Report"
      none
      searchQuery={searchQuery}
      setSearchQuery={setSearchQuery}
      selectedFrom={from}
      setSelectedFrom={setFrom}
      selectedTo={to}
      setSelectedTo={setTo}
      headers={pdfCsvData.headings}
      data={pdfCsvData.headingValues}
      filename="achievement_report"
    >
      <CustomTable>
        <CustomTableHeading
          filterIcons={{
            Employee: <SortIcon onClick={() => setFilterParams({ ...filterParams, storeName: '', firstName: filterParams.firstName === 1 ? -1 : 1 })} value={filterParams.firstName} />,
            store: <SortIcon onClick={() => setFilterParams({ ...filterParams, firstName: '', storeName: filterParams.storeName === 1 ? -1 : 1 })} value={filterParams.storeName} />,
          }}
          heading={['Employee', 'Employee Code', 'store', 'store code', 'From', 'To', 'Target Value', 'Total Sale', 'Sale %']}
        />
        <TableBody>
          {!loading &&
            incentives.map((item) => {
              return (
                item.allTargetOfStore &&
                item.allTargetOfStore.map((target) => {
                  let todayDate = new Date().toISOString().slice(0, 10)

                  let { targetDuration } = target

                  // targetDuration = targetDuration.filter((tar) => tar && tar.targetFrom <= todayDate && tar.targetTo >= todayDate)

                  return targetDuration.map((tar, index) => {
                    if (!tar.totalSaleAmount) tar.totalSaleAmount = 0
                    return (
                      <CustomTableRow key={index}>
                        <TableCell> {item.employeeName} </TableCell>
                        <TableCell> {item.employeeCode} </TableCell>
                        <TableCell>{item.storeName}</TableCell>
                        <TableCell>{item.storeCode}</TableCell>
                        <TableCell>{formatDate(tar.targetFrom)}</TableCell>
                        <TableCell>{formatDate(tar.targetTo)}</TableCell>
                        <TableCell>{formatNumber(tar.targetAmount)}</TableCell>
                        <TableCell>{formatNumber(tar.totalSaleAmount)}</TableCell>
                        <TableCell>{((tar.totalSaleAmount / tar.targetAmount) * 100).toFixed()} %</TableCell>
                      </CustomTableRow>
                    )
                  })
                })
              )
            })}
        </TableBody>
      </CustomTable>

      {!loading && incentives.length > 0 && <CustomPagination noOfPages={noOfPages} page={page} handleChange={handleChange} />}

      {!loading && incentives.length == 0 && <NoDataFound />}

      {loading && <Loader />}
    </Layout>
  )
}
